<template>
  <b-container fluid>
    <b-row>
      <b-col cols="8" class="mx-auto">
        <b-card v-if="preview">
          <b-row>
            <b-col cols="6">
              <b-card-text
                class="pa-0 ma-0"
              >You are previewing potential changes, please save your work to complete changes.</b-card-text>
            </b-col>
            <b-col cols="6">
              <b-button variant="primary" @click="save" class="mr-3">Save</b-button>
              <b-button
                variant="outline-secondary"
                :to="{name: 'adminDashboard', params: {tab:'privacy', policy: privacyPolicy}}"
                class="pa-0 ma-0"
              >
                <b-icon-arrow-left />return to editing
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col cols="8" class="mx-auto">
        <b-card>
          <b-card-text v-html="privacyPolicy.data" />
        </b-card>
        <a href="#" class="text-center">
          <b-icon-arrow-up />Return to top
        </a>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {PrivacyPolicy} from '@/fstore/collections/siteDocuments'
export default {
  name: "PrivacyPolicy",
  data () {
    return {
      preview: false,
      privacyPolicy: {
        created: new Date(),
        data: '',
        modified: new Date()
      },
    }
  },
  async created () {
    if(this.$route.params.policy){
      this.preview = true;
      this.privacyPolicy = this.$route.params.policy;
    }
    else
      this.privacyPolicy = await PrivacyPolicy.get();
  },
  methods:{
    async save() {
      if(this.preview) {
        this.$store.dispatch('app/setOverlay', true);
        await PrivacyPolicy.set(this.privacyPolicy);
        this.$store.dispatch('app/setOverlay', false);
        this.$router.push({name:'adminDashboard', params:{tab: 'privacy'}})
      }
    }
  }
}
</script>